<div class="header">
    <div>
        <h4 class="title">{{ filtersTitle }}</h4>
        <button class="cm-link" (click)="resetFilters.emit()">Reset to default</button>
    </div>
    <button (click)="closeSideBar.emit()" class="btn close-btn"></button>
</div>
<div class="content-container"><ng-content></ng-content></div>
<div class="footer">
    <span class="results-found">{{ count }} results found</span>
</div>
